// extracted by mini-css-extract-plugin
export var form_inputs = "style-module--form_inputs--11Aog";
export var form_submit = "style-module--form_submit--3ijva";
export var form_submit_accept = "style-module--form_submit_accept--3UgHH";
export var form_submit_btn = "style-module--form_submit_btn--1Miol";